import styled from 'styled-components';
// @ts-expect-error module not typed
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getSubject
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledBig = styled.big.withConfig({
  displayName: "ForwardSubject__StyledBig",
  componentId: "e3trpo-0"
})(["font-size:14px;align-self:flex-start;padding:8px 0 0;"]);
export const ForwardSubject = ({
  message
}) => {
  return /*#__PURE__*/_jsx(StyledBig, {
    className: "is--text--bold",
    children: getSubject(message)
  });
};
ForwardSubject.displayName = 'ForwardSubject';
ForwardSubject.propTypes = {
  message: RecordPropType('CommonMessage').isRequired
};